﻿if ($("#leadMagnetModal").length > 0) {

    var popupendpoint = leadMagnetPopup_endpoint;
    var emailReg = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;

    var popupData = {
        firstname: '',
        lastname: '',
        email: '',
        pageurl: ''
    };

    var fname = true,
        email = true,
        lname = true;

    $("#leadMagnetModal input[name='email']").blur(function () {
        if ($(this).val() == "" || !emailReg.test($(this).val())) {
            $(this).addClass('red-border');
            email = true;
        } else {
            $(this).removeClass('red-border');
            email = false;
        }
    });

    $("#leadMagnetModal input[name='firstname']").blur(function () {
        if ($(this).val().trim() == "") {
            $(this).addClass('red-border');
            fname = true;
        } else {
            $(this).removeClass('red-border');
            fname = false;
        }
    });
    $("#leadMagnetModal input[name='firstname']").keyup(function () {
        if ($(this).val().trim() == "") {
            $(this).addClass('red-border');
            fname = true;
        }
        else {
            $(this).removeClass('red-border');
            fname = false;
        }

    });

    $("#leadMagnetModal input[name='lastname']").blur(function () {
        if ($(this).val().trim() == "") {
            $(this).addClass('red-border');
            lname = true;
        } else {
            $(this).removeClass('red-border');
            lname = false;
        }
    });
    $("#leadMagnetModal input[name='lastname']").keyup(function () {
        if ($(this).val().trim() == "") {
            $(this).addClass('red-border');
            lname = true;
        }
        else {
            $(this).removeClass('red-border');
            lname = false;
        }

    });


    $('#btnSubmitLeadMagnetPopup').click(function () {

        if (fname === true || email === true) {
            event.preventDefault();
            $("#leadMagnetModal input[name='firstname'],#leadMagnetModal input[name='email'],#leadMagnetModal input[name='lastname']").blur();
            return false;
        }
        popupData.firstname = $('#leadMagnetModal').find('#firstname').val();
        popupData.lastname = $('#leadMagnetModal').find('#lastname').val();
        popupData.email = $('#leadMagnetModal').find('#email').val();
        popupData.pageurl = window.location.href;

        $.ajax({
            url: popupendpoint,
            type: 'POST',
            dataType: 'json',
            data: JSON.stringify(popupData),
            contentType: 'application/json; charset=utf-8',
            success: function (data) {
                $("#leadMagnetModal input[type='text'").val('');
                $('#leadMagnetModal').find('.close').click();
                window.open(data.FileURL, '_blank');
                return data;
            }
        });
    });
}

if ($("#CCPAModal").length > 0) {

    var popupendpoint = ccpaPopup_endpoint;
    var emailReg = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    var phoneReg = /^[01]?[- .]?(\([2-9]\d{2}\)|[2-9]\d{2})[- .]?\d{3}[- .]?\d{4}$/;

    var ccpaData = {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        comments: '',
        pageurl: '',
        grecaptcharesponse: ''

    };

    var fname = true,
        lname = true,
        phone = true,
        email = true,
        comments = true,
        captcha = true;

    $("#CCPAModal").on('hidden.bs.modal', function () {
        $("#CCPAModal #privacyformfields").show();
        $('#CCPAModal .modal-footer').show();
        $('#CCPAModal #privacythankyou').hide();
    });
    //$("#CCPAModal").on('shown.bs.modal', function (e) {
    //    if (typeof grecaptcha !== 'undefined') {
    //        grecaptcha.ready(function () {
    //            grecaptcha.render('popup-captcha', {
    //                'sitekey': '6LccvT4jAAAAABDz1-rihUVH8_gq4iJHF-pz0Gnw'
    //            });
    //        });
    //    }
    //});

    $("#CCPAModal input[name='email']").blur(function () {
        if ($(this).val() == "" || !emailReg.test($(this).val())) {
            $(this).addClass('red-border');
            email = true;
        } else {
            $(this).removeClass('red-border');
            email = false;
        }
    });

    $("#CCPAModal input[name='firstname']").on('blur', function () {
        if ($(this).val().trim() == "") {
            var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
            $(this).addClass('red-border');
            $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
            $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
            fname = true;
        } else {
            $(this).removeClass('red-border');
            $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
            fname = false;
        }
    });
    $("#CCPAModal input[name='lastname']").on('blur', function () {
        if ($(this).val().trim() == "") {
            var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
            $(this).addClass('red-border');
            $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
            $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
            lname = true;
        } else {
            $(this).removeClass('red-border');
            $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
            lname = false;
        }
    });

    $("#CCPAModal #comments").on('blur', function () {
        if ($(this).val().trim() == "") {
            var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
            $(this).addClass('red-border');
            $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
            $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
            comments = true;
        } else {
            $(this).removeClass('red-border');
            $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
            comments = false;
        }
    });

    $("#CCPAModal input[name='phone']").blur(function () {
        if (!phoneReg.test($(this).val())) {
            $(this).addClass('red-border');
            phone = true;
        } else {
            $(this).removeClass('red-border');
            phone = false;
        }
    });

    $("#CCPAModal input[name='firstname']").keyup(function () {
        if ($(this).val().trim() == "") {
            $(this).addClass('red-border');
            fname = true;
        }
        else {
            $(this).removeClass('red-border');
            fname = false;
        }

    });

    $("#CCPAModal input[name='lastname']").keyup(function () {
        if ($(this).val().trim() == "") {
            $(this).addClass('red-border');
            lname = true;
        } else {
            $(this).removeClass('red-border');
            lname = false;
        }

    });

    async function generateCaptchaKey(formtype) {
        // --- reCAPTCHA v3: execute and get token ---
        let captchaToken;
        try {
            captchaToken = await grecaptcha.enterprise.execute('6Lc0VPUsAAAAAB9wa0NuA-T8Ko1IGn06U9-HsSr-', { action: formtype });
            return captchaToken;
        } catch (err) {
            console.error('reCAPTCHA execution failed', err);
            $('.captcha-error').show();
            $(this).show();
            return ''; // Stop submission if reCAPTCHA itself errors
        }
    }

    $('#btnSubmitCCPAPopup').on('click', async function (event) {
        event.preventDefault();

        $("#CCPAModal input.required,#CCPAModal #comments").blur();

        // Recalculate validation
        let fname = $('#firstname').val().trim() === '';
        let lname = $('#lastname').val().trim() === '';
        let email = $('#email').val().trim() === '';
        let phone = $('#phone').val().trim() === '';
        let comments = $('#comments').val().trim() === '';

        let captchaToken = await generateCaptchaKey('CCPAForm');

        if (captchaToken != '') {
            // Inject the token into your hidden field for server-side verification
            document.getElementById('g-recaptcha-response').value = captchaToken;
            captcha = false;
            $('.captcha-error').hide();
        } else {
            $('.captcha-error').show();
            captcha = true;
        }

        // --- end reCAPTCHA v3 block ---

        if (fname || lname || email || phone || comments || captcha) {

            return false;
        }

        ccpaData.firstname = $('#CCPAModal').find('#firstname').val();
        ccpaData.lastname = $('#CCPAModal').find('#lastname').val();
        ccpaData.email = $('#CCPAModal').find('#email').val();
        ccpaData.phone = $('#CCPAModal').find('#phone').val();
        ccpaData.comments = $('#CCPAModal').find('#comments').val();
        ccpaData.pageurl = window.location.href;
        ccpaData.grecaptcharesponse = captchaToken; // assuming Google Recaptcha v3
        $.ajax({
            url: popupendpoint,
            type: 'POST',
            data: JSON.stringify(ccpaData),
            contentType: 'application/json',
            success: function (data) {
                $("#CCPAModal input[type='text']").val('');
                $("#CCPAModal textarea").val('');
                $("#CCPAModal #privacyformfields").hide();
                $('#CCPAModal .modal-footer').hide();
                $('#CCPAModal #privacythankyou').show();
                //window.open(data.FileURL, '_blank');
                return data;
            },
            error: function (xhr) {

            }
        });
    });

}